import * as testData from '../mocks/testData.js';
import { testStatementPosition } from './statementPosition.js';

const SQLEditorTestUtils = {
  testData,
  testStatementPosition
};

export { SQLEditorTestUtils };
//# sourceMappingURL=index.js.map
